import { TypographyVariant } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import CopyDataToClipboard from '../CopyDataToClipboard';
import { copyableLabelStyle } from './style';

type CopyableLabelProps = {
  labelText: string,
  dataToCopy: string,
  variant: TypographyVariant,
  maxWidth: string,
  textColor: string
};

const CopyableLabel = ({
  dataToCopy, labelText, variant, maxWidth, textColor,
}: CopyableLabelProps):JSX.Element => (
  <Box sx={ copyableLabelStyle.c2.sx(maxWidth, textColor) }
    style={ copyableLabelStyle.c2.containerBox }
  >
    <Typography noWrap
      variant={ variant }
      style={ copyableLabelStyle.hoverLabel }
    >
      {labelText}
    </Typography>

    <Box sx={ copyableLabelStyle.hoverContainer }>
      <Typography noWrap
        variant={ variant }
      >
        {labelText}
      </Typography>
      <CopyDataToClipboard dataToCopy={ dataToCopy } />
    </Box>
  </Box>
);

export default CopyableLabel;
